export default "__VITE_ASSET__DEaKvy7o__"